<template>
  <div v-if="showFab">
    <div class="assistant-fab" title="飞鸟智能助手" @click="visible = true">AI</div>
    <el-drawer
      :title="`飞鸟智能助手${contextTitle ? ' · ' + contextTitle : ''}`"
      :visible.sync="visible"
      size="520px"
      append-to-body
    >
      <div class="drawer-body">
        <div class="drawer-actions">
          <el-button size="mini" icon="el-icon-plus" @click="newSession">新会话</el-button>
          <el-button size="mini" icon="el-icon-download" @click="goDownloads">下载中心</el-button>
        </div>
        <assistant-chat
          v-if="visible"
          :session-id="sessionId"
          :context-title="contextTitle"
          @session="onSessionCreated"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import AssistantChat from './AssistantChat.vue'

/**
 * 全局助手抽屉（挂在 App.vue，登录后任意页面可唤起）
 * 上下文感知：显示当前路由标题，可一键生成"分析当前页面"提问
 */
export default {
  name: 'AssistantDrawer',
  components: { AssistantChat },
  data () {
    return {
      visible: false,
      sessionId: ''
    }
  },
  computed: {
    showFab () {
      return this.$route.path !== '/login' && !!window.sessionStorage.getItem('token')
    },
    contextTitle () {
      return (this.$route.meta && this.$route.meta.title) || ''
    }
  },
  methods: {
    newSession () {
      this.sessionId = ''
    },
    goDownloads () {
      this.visible = false
      this.$router.push('/assistant/downloads')
    },
    onSessionCreated (sessionId) {
      this.sessionId = sessionId
    }
  }
}
</script>

<style scoped>
.assistant-fab {
  position: fixed;
  right: 24px;
  bottom: 88px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  z-index: 2000;
  user-select: none;
}
.assistant-fab:hover {
  background: #66b1ff;
}
.drawer-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 12px 12px;
  box-sizing: border-box;
}
.drawer-actions {
  padding: 4px 0 8px;
}
.drawer-body .assistant-chat {
  flex: 1;
  min-height: 0;
}
</style>
